import pathfinder from '@fiverr-private/pathfinder';
import { LoyaltyProgramTier } from '@fiverr-private/loyalty_utils';
import type { BiEnrichment } from '../../events/bigQuery';
import { countEventDispatch } from '../../events/countEvent';
import { shouldDisplayMigrationPopup } from '../UserMigration';
import { ModalType } from './types';

export const MIGRATION_MODAL_EVENT_NAME = 'fipMigrationModal:open' as keyof WindowEventMap;

interface TierContext {
    tier: LoyaltyProgramTier;
    tierAlreadyReached?: boolean;
}

export interface SeamlessModalPayloadValue {
    source: string;
    biEnrichment: BiEnrichment;
    withLoadingStep?: boolean;
    tierContext?: TierContext;
    onSuccess?(args: { organizationId: string; balanceInUsdCents?: number }): void;
    onClose?: (modalOnClose?: () => void) => void;
    onSkip?: () => void;
}

export interface ModalPayload {
    variant: ModalType;
    payload: SeamlessModalPayloadValue;
    callbackWhenNotMounted?: () => void;
}

export const IS_MIGRATION_MANAGER_MOUNTED = 'IS_MIGRATION_MODAL_MANAGER_MOUNTED';

export const openFipMigrationModal = (detail: ModalPayload) => {
    if (!window[IS_MIGRATION_MANAGER_MOUNTED]) {
        const { callbackWhenNotMounted, payload, variant } = detail;
        if (callbackWhenNotMounted) {
            callbackWhenNotMounted?.();

            return;
        }

        if (variant === ModalType.FullMigration) {
            goToFullMigrationPage({ source: payload.source });
        }
    }

    const event = new CustomEvent(MIGRATION_MODAL_EVENT_NAME, {
        detail,
    });

    countEventDispatch({ type: detail.variant, source: detail.payload.source });
    window.dispatchEvent(event);
};

export const shouldDisplayFullMigrationModal = shouldDisplayMigrationPopup;

export const openFipFullMigrationModal = (payload: SeamlessModalPayloadValue) => {
    openFipMigrationModal({
        variant: ModalType.SeamlessUpgradeToPro,
        payload,
    });
};

export const goToFullMigrationPage = ({ source }: { source: SeamlessModalPayloadValue['source'] }) => {
    const linkToMigration = pathfinder('business_user_migration_new', {}, { query: { source } });
    window.location.assign(linkToMigration);
};
